import './Page404.css';
import { Link, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

function Page404() {
    const [clickCount, setClickCount] = useState(0);
    const navigate = useNavigate();

    // Обновляем title при изменении clickCount
    useEffect(() => {
        document.title = `${String.fromCharCode(8203)}${5 - clickCount}${String.fromCharCode(8203)} | 404`;
    }, [clickCount]);

    const handleTitleClick = () => {
        const newCount = clickCount + 1;
        setClickCount(newCount);
        
        if (newCount >= 5) {
            navigate('/Easteregg');
        }
    };

    return (
        <div className="err-page">
            <img 
                src="https://cdn-icons-png.flaticon.com/512/2232/2232688.png" 
                className="err-school err-school-1" 
                alt="Школьная доска" 
            />
            <img 
                src="https://cdn-icons-png.flaticon.com/512/2936/2936886.png" 
                className="err-school err-school-2" 
                alt="Школьный рюкзак" 
            />

            <h1 className="err-title" onClick={handleTitleClick}>404</h1>
            <h2 className="err-subtitle">Классная комната исчезла!</h2>
        
            <p className="err-text">
                Ой-ой! Похоже, этот класс отправился на перемену
            </p>
            
            <div>
                <Link to="/" className="err-btn">Вернуться на главную</Link>
            </div>
            
            <p className="err-footer">
                P.S. Если это читает наш директор — то мы уже чиним!
            </p>
        </div>
    );
}

export default Page404;